import { ChangeEvent } from 'react';
import AccordionComponent from '../common/Accordion';
import RadioGroupComponent from '../common/RadioGroup';
import styles from './styles';

export interface IAdminFilterModalProps {
    selectedStatus?: string | number | boolean;
    selectedPeriod?: string | number | boolean;
    onStatusChange?: (event: ChangeEvent<HTMLInputElement>) => void;
    onPeriodChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}
const statusData = [
    {
        value: 'active',
        label: 'Active',
    },
    {
        value: 'inActive',
        label: 'Inactive',
    },
];

const additionPeriodData = [
    {
        value: 'lastWeek',
        label: 'Last 7 Days',
    },
    {
        value: 'lastMonth',
        label: 'Last Month',
    },
    {
        value: 'lastSixMonths',
        label: 'Last 6 Months',
    },
    {
        value: 'lastYear',
        label: 'Last Year',
    },
];

const PartnerFilterModal = ({
    selectedStatus,
    selectedPeriod,
    onStatusChange,
    onPeriodChange,
}: IAdminFilterModalProps) => {
    return (
        <AccordionComponent
            data={[
                {
                    summary: 'Status',
                    detailsNode: (
                        <RadioGroupComponent
                            classes={styles.radioGroupLabel}
                            data={statusData}
                            selectedValue={selectedStatus}
                            name="status"
                            onChange={onStatusChange}
                        />
                    ),
                },
                {
                    summary: 'Addition Period',
                    detailsNode: (
                        <RadioGroupComponent
                            classes={styles.radioGroupLabel}
                            data={additionPeriodData}
                            selectedValue={selectedPeriod}
                            name="additional-period"
                            onChange={onPeriodChange}
                        />
                    ),
                },
            ]}
        />
    );
};
export default PartnerFilterModal;
